module.exports = __webpack_public_path__ + "img/copper_api_key.b1ea4454.png";